export default __webpack_public_path__ + "static/media/HDTX_Annual Report 2024.d3811b06.pdf";